import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TimeOffService } from '@app/modules/time-off/services/time-off.service';
import { MyRequest } from '@app/shared/models/workflows-absences/workflows-absences.model';

@Component({
  selector: 'app-approval-list-item',
  templateUrl: './approval-list-item.component.html',
  styleUrls: ['./approval-list-item.component.scss']
})
export class ApprovalListItemComponent implements OnInit {
  @Output() openPendingTimeOffDialog = new EventEmitter<MyRequest>();
  @Input() timeOffLeaveRequest;
  iconUrl: string;

  constructor(
    private timeOffService: TimeOffService,
    public domSanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.timeOffService.getTimeOffTypeIcon(this.timeOffLeaveRequest?.timeOffType?.id)
    .subscribe(
      res => {
        this.iconUrl = res?.url;
      }
    )
  }

}
